import axios from "axios";
import { useEffect, useState } from "react";
import "./adminorders.css";

export default function AdminOrders() {

  const [orders, setOrders] = useState([]);

  // ✅ LOAD ORDERS
  const loadOrders = () => {

    axios
      .get("https://apple2.shopat1stop.com/api/orders")
      .then(res => setOrders(res.data))
      .catch(() => setOrders([]));

  };

  useEffect(() => {
    loadOrders();
  }, []);

  // ✅ UPDATE STATUS
  const updateStatus = (id, status) => {

    axios.put(
      `https://apple2.shopat1stop.com/api/orders/${id}`,
      { status }
    )
    .then(() => {
      loadOrders();
    });

  };

  return (
    <div className="admin-orders">

      <h1>📦 Orders Management</h1>

      {orders.map(order => (

        <div className="order-card" key={order.id}>

          <h2>Order #{order.id}</h2>

          <p>
            <b>Customer:</b> {order.customer_name}
          </p>

          <p>
            <b>Phone:</b> {order.phone}
          </p>

          <p>
            <b>Address:</b> {order.address}
          </p>

          <p>
            <b>City:</b> {order.city}
          </p>

          <p>
            <b>ZIP:</b> {order.zip}
          </p>

          <p>
            <b>Payment:</b> {order.payment_method}
          </p>

          <p>
            <b>Total:</b> ${order.total}
          </p>

          <p>
            <b>Status:</b>
            <span className={`status ${order.status}`}>
              {order.status}
            </span>
          </p>

          {/* STATUS BUTTONS */}
          <div className="status-buttons">

            <button
              onClick={() =>
                updateStatus(order.id, "Pending")
              }
            >
              Pending
            </button>

            <button
              onClick={() =>
                updateStatus(order.id, "Packed")
              }
            >
              Packed
            </button>

            <button
              onClick={() =>
                updateStatus(order.id, "Shipped")
              }
            >
              Shipped
            </button>

            <button
              onClick={() =>
                updateStatus(order.id, "Delivered")
              }
            >
              Delivered
            </button>

          </div>

        </div>

      ))}

    </div>
  );
}